import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { isAndroid } from "react-device-detect";
import zIndex from "@material-ui/core/styles/zIndex";

import { useStore } from "../../store";
import { BackdropPanel, CircleProgress } from "../../components";
import { MuiBackdropButton } from "../../components/BackdropPanel/style";
import { getWebBridge } from "../../utils/webBridge";
import { TranslationJSX } from "../../utils/Translation";

const DetailPanelDownload = () => {
  const {
    detailStore: {
      downloadState: { isDownload, percentage },
      onDownloadCancel,
      onDownloadProgress,
    },
  } = useStore();

  useEffect(() => {
    if (isAndroid) {
      getWebBridge({ name: "onProgressStatus", callBack: onDownloadProgress });
    }
    getWebBridge({ name: "onDownloadProgress", callBack: onDownloadProgress });

    // eslint-disable-next-line
  }, []);

  const cancelButtonDisabled = percentage === 100;
  const progressValue = () => {
    if (!percentage) return 0;
    if (percentage > 100) return 100;
    return percentage;
  };

  return (
    <BackdropPanel isOpen={isDownload} style={{ zIndex: zIndex.snackbar }}>
      <CircleProgress
        size={74}
        thickness={2}
        value={progressValue()}
        color="secondary"
      />
      <MuiBackdropButton
        disabled={cancelButtonDisabled}
        onClick={() => onDownloadCancel()}
      >
        <TranslationJSX locoKey="feed_cancel_button" />
      </MuiBackdropButton>
    </BackdropPanel>
  );
};

export default observer(DetailPanelDownload);
